import {UI} from "../../../stem-core/src/ui/UIBase";

import {styleRuleInherit} from "../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../stem-core/src/ui/style/Theme";
import {IndexExpanded} from "../pages/index-expanded/IndexExpanded";
import {WalletPopup, WalletPopupStyle} from "./WalletPopup";


class MerchantPopupStyle extends WalletPopupStyle {
    @styleRuleInherit
    popup = {
        background: this.themeProps.MERCHANT_POPUP_BACKGROUND,
        boxShadow: this.themeProps.MERCHANT_POPUP_SHADOW,
    };

    @styleRuleInherit
    visible = {
        borderRadius:  "4px 4px 0 0",
    };
}

export function MerchantPopup(CardClass) {
    @registerStyle(MerchantPopupStyle)
    class Popup extends WalletPopup(CardClass) {
        static getParentNode() {
            // TODO @cleanup this is an abomination, aha
            return IndexExpanded.instance.innerContainer.node;
        }
    }

    return Popup;
}
